import React, { useState } from 'react';
import logo from '../img/logo.png';
import { FaBars } from 'react-icons/fa';

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className='fixed w-full z-50'>
      <header className="bg-neutral-50 shadow-md py-4">
        <div className="flex items-center justify-center px-6">
          <a href="/"><img src={logo} alt="Logo" className='h-10' /></a>
        </div>
      </header>
    </div>
  );
}

export default NavBar;
